import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Terminal from "./pages/Terminal";
import Presence from "./pages/Presence";
import ControlLogin from "./pages/ControlLogin";
import ControlDashboard from "./pages/ControlDashboard";
import ControlDevices from "./pages/ControlDevices";
import ControlEmployees from "./pages/ControlEmployees";
import ControlAudit from "./pages/ControlAudit";
import ControlSignals from "./pages/ControlSignals";
import ControlOps from "./pages/ControlOps";
import ControlAccess from "./pages/ControlAccess";
import PeopleLogin from "./pages/people/PeopleLogin";
import PeopleReviews from "./pages/people/PeopleReviews";
import PeopleOverrides from "./pages/people/PeopleOverrides";
import PeoplePayroll from "./pages/people/PeoplePayroll";
import PeopleDevices from "./pages/people/PeopleDevices";
import PeopleAudit from "./pages/people/PeopleAudit";
import { getManagerToken, getPeopleEngineToken } from "./lib/api";
import { Toaster } from "./components/ui/sonner";

function RequireManager({ children }) {
  const token = getManagerToken();
  if (!token) return <Navigate to="/control/login" replace />;
  return children;
}

function RequirePeopleEngine({ children }) {
  const token = getPeopleEngineToken();
  if (!token) return <Navigate to="/people/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        {/* Presence — capture-only.
            "/" IS Presence. There is no separate landing/launcher page;
            Presence is a single-purpose tool, not a dashboard. */}
        <Route path="/" element={<Terminal />} />
        <Route path="/terminal" element={<Terminal />} />
        <Route path="/presence" element={<Presence />} />

        {/* Control Room — governance + read-only monitoring (separate URL, not linked from Presence) */}
        <Route path="/control/login" element={<ControlLogin />} />
        <Route path="/control" element={<Navigate to="/control/dashboard" replace />} />
        <Route path="/control/dashboard" element={<RequireManager><ControlDashboard /></RequireManager>} />
        <Route path="/control/devices" element={<RequireManager><ControlDevices /></RequireManager>} />
        <Route path="/control/employees" element={<RequireManager><ControlEmployees /></RequireManager>} />
        <Route path="/control/audit" element={<RequireManager><ControlAudit /></RequireManager>} />
        <Route path="/control/signals" element={<RequireManager><ControlSignals /></RequireManager>} />
        <Route path="/control/ops" element={<RequireManager><ControlOps /></RequireManager>} />
        <Route path="/control/access" element={<RequireManager><ControlAccess /></RequireManager>} />
        <Route path="/control/review" element={<Navigate to="/people/login" replace />} />

        {/* People's Engine — workforce decision surface (separate URL, not linked from Presence) */}
        <Route path="/people/login" element={<PeopleLogin />} />
        <Route path="/people" element={<Navigate to="/people/reviews" replace />} />
        <Route path="/people/reviews" element={<RequirePeopleEngine><PeopleReviews /></RequirePeopleEngine>} />
        <Route path="/people/overrides" element={<RequirePeopleEngine><PeopleOverrides /></RequirePeopleEngine>} />
        <Route path="/people/payroll" element={<RequirePeopleEngine><PeoplePayroll /></RequirePeopleEngine>} />
        <Route path="/people/devices" element={<RequirePeopleEngine><PeopleDevices /></RequirePeopleEngine>} />
        <Route path="/people/audit" element={<RequirePeopleEngine><PeopleAudit /></RequirePeopleEngine>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
